import type { CountdownUnit, UrgencyBarColor } from './types';

export const urgencyCountdownThresholdMs = 7 * 24 * 60 * 60 * 1000;

export const defaultCountdownUnits: CountdownUnit[] = [
  'days',
  'hours',
  'minutes',
  'seconds',
];

export const highlightClasses: Record<
  UrgencyBarColor,
  {
    background: string;
    text: string;
  }
> = {
  orange: {
    background: 'bg-highlights/orange-light',
    text: 'text-buttons/cta',
  },
  yellow: {
    background: 'bg-highlights/yellow-light',
    text: 'text-highlights/yellow-dark',
  },
  green: {
    background: 'bg-highlights/green-light',
    text: 'text-highlights/green-dark',
  },
  blue: {
    background: 'bg-highlights/blue-light',
    text: 'text-highlights/blue-dark',
  },
  red: {
    background: 'bg-highlights/red-light',
    text: 'text-highlights/red-dark',
  },
  gray: {
    background: 'bg-highlights/gray-light',
    text: 'text-highlights/gray-dark',
  },
};
